<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="{ tablet: 'top' }[$device.currentSize] ?? 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('소속 사업장')">
              <el-select
                v-model="searchForm.topCustCd"
                filterable
                remote
                default-first-option
                clearable
                :placeholder="$t('사업장명을 입력 하여 검색')"
                :remote-method="custSearch">
                <el-option
                  v-for="item in cust"
                  :key="item.custCd"
                  :label="item.custNm"
                  :value="item.custCd"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('사업장명')">
              <el-input v-model="searchForm.custNm" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('CustSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CustAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CustUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CustDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
    </div>

    <!-- 요약 — 두 수 모두 **이 조건의 전체**다. 한 장(50건)을 세면 페이지를 넘길 때마다 합계가 바뀐다 -->
    <div class="cust-summary">
      <span>{{ $t('전체 사업장') }} {{ totalElements }}건</span>
      <span>{{ $t('총 매장 수') }} {{ totalStoreCount }}개</span>
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        fixed
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 중첩 열 `topCust.custNm`·`bankTp.nmLan` 은
           [sortAliases] 가 서버의 컬럼 이름(`topCustNm`·`bankTpNm`)으로 옮긴다 -->
      <el-table-column
        :label="$t('사업장 코드')"
        prop="custId"
        width="90"
        align="center"
        :fixed="!$device.mobile"></el-table-column>
      <el-table-column
        :label="$t('사업장명')"
        prop="custNm"
        min-width="200"
        fixed
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('매장 수')" prop="storeCount" width="90" align="center" sortable="custom">
        <template slot-scope="scope">{{ scope.row.storeCount || 0 }}개</template>
      </el-table-column>
      <el-table-column
        :label="$t('소속 사업장명')"
        prop="topCust.custNm"
        min-width="200"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사업자 등록 번호')"
        prop="busiNum"
        :formatter="bizNoFormatter"
        min-width="140"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('핸드폰 번호')"
        prop="tel"
        :formatter="util.telCell"
        min-width="130"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('팩스 번호')"
        prop="fax"
        :formatter="util.telCell"
        min-width="130"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('대표자명')"
        prop="ceoNm"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('가입일')"
        prop="startDt"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('탈퇴일')"
        prop="endDt"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('정산계좌번호')"
        prop="accountNumber"
        min-width="120"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('정산은행')"
        prop="bankTp.nmLan"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('예금주명')"
        prop="accountName"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column :label="$t('우편 번호')" prop="zipCd" min-width="80" align="center"></el-table-column>
      <el-table-column :label="$t('주소')" prop="addr" min-width="300" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('상세 주소')" prop="addrDtl" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('설명')" prop="custDesc" min-width="300" show-overflow-tooltip></el-table-column>
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        :label-width="$device.mobile ? `` : `180px`"
        :label-position="$device.mobile ? `top` : ''"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row v-if="'I' === inputForm.statu || null != inputForm.topCust.custCd">
          <el-col :md="12">
            <el-form-item :label="$t('소속 사업장')" :error="formError['topCust.custCd']">
              <el-select
                v-model="inputForm.topCust.custCd"
                filterable
                remote
                default-first-option
                style="width: 100%"
                :placeholder="$t('사업장명을 입력 하여 검색')"
                :remote-method="custSearch"
                v-if="'I' === inputForm.statu">
                <el-option
                  v-for="item in cust"
                  :key="item.custCd"
                  :label="item.custNm"
                  :value="item.custCd"></el-option>
              </el-select>
              <span class="show_cd">{{ inputForm.topCust.custNm }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('사업장명')" :error="formError.custNm" required>
              <el-input v-model="inputForm.custNm" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('사업자 등록 번호')" :error="formError.busiNum">
              <el-input
                v-keep-number-caret
                :value="util.bizNoFieldText(inputForm.busiNum)"
                maxlength="20"
                clearable
                show-word-limit
                @input="inputForm.busiNum = util.bizNoInputValue($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('대표자명')" :error="formError.ceoNm" required>
              <el-input v-model="inputForm.ceoNm" maxlength="20" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('사용 가능 여부')" required>
              <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <ceo-verification-line :block="inputForm.ceoVerification"></ceo-verification-line>
          <el-col :md="12">
            <el-form-item :label="$t('전화번호')" :error="formError.tel" required>
              <el-input
                v-keep-number-caret
                :value="util.telFieldText(inputForm.tel)"
                maxlength="20"
                clearable
                show-word-limit
                @input="inputForm.tel = util.telDigits($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('팩스번호')" :error="formError.fax">
              <el-input
                v-keep-number-caret
                :value="util.telFieldText(inputForm.fax)"
                maxlength="20"
                clearable
                show-word-limit
                @input="inputForm.fax = util.telDigits($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('이메일')" :error="formError.email">
              <el-input v-model="inputForm.email" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('가입일')" :error="formError.startDt" required>
              <el-date-picker
                v-model="inputForm.startDt"
                type="date"
                :placeholder="$t('가입일')"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('탈퇴일')" :error="formError.endDt">
              <el-date-picker
                v-model="inputForm.endDt"
                type="date"
                :placeholder="$t('탈퇴일')"
                value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('정산은행')" :error="formError['bankTp.cd']">
              <code-combo :data="bankTp" :model="inputForm.bankTp" @change="inputForm.bankTp = $event"></code-combo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('정산계좌번호')" :error="formError.accountNumber">
              <el-input
                v-model="inputForm.accountNumber"
                maxlength="20"
                clearable
                show-word-limit
                @keyup.native="inputForm.accountNumber = util.inputBusiNumNew($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('예금주명')" :error="formError.accountName">
              <el-input v-model="inputForm.accountName" maxlength="20" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('우편 번호')" :error="formError.zipCd" required>
              <el-input
                v-model="inputForm.zipCd"
                maxlength="10"
                show-word-limit
                style="width: 200px"
                readonly></el-input>
              <el-button @click="selectAddress()">{{ $t('주소 조회') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('주소')" :error="formError.addr" required>
              <el-input v-model="inputForm.addr" maxlength="250" show-word-limit readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('상세 주소')" :error="formError.addrDtl" required>
              <el-input ref="addr_dtl" v-model="inputForm.addrDtl" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="24">
            <el-form-item :label="$t('설명')" :error="formError.custDesc">
              <el-input v-model="inputForm.custDesc" type="textarea" maxlength="250" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :md="8">
            <el-form-item :label="$t('첨부 파일')">
              <el-upload
                action=""
                class="avatar-uploader"
                accept="image/*"
                :auto-upload="false"
                :file-list="inputForm.files"
                :on-change="custFileAdd"
                :on-remove="custFileRemove"
                multiple
                list-type="picture">
                <el-button slot="trigger" size="small" type="primary">{{ $t('파일 추가') }}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <div style="margin-top: 30px">&nbsp;</div>
            <div
              v-for="(item, index) in inputForm.files"
              :key="index"
              class="file_name"
              style="margin-top: 10px; height: 92px"
              v-if="'del' != inputForm.files[index].status">
              <el-input
                v-model="inputForm.files[index].name"
                maxlength="50"
                show-word-limit
                :size="size"
                type="textarea"
                resize="none"
                rows="4"
                @change="fileNameChange(inputForm.files[index])"></el-input>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import { pickAddress } from '@/utils/addressPicker'
import { CUST_OPTIONS_API, custOptionsQuery } from '@/utils/custOptions'
import { announceInitialAccount } from '@/utils/initialAccount'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { util } from '@/mixins/utilMixin'
import { bizNoDisplay } from '@/utils/bizNumber'
import { pageRows, withPaging } from '@/utils/pagedList'
import CeoVerificationLine from '@/components/common/CeoVerificationLine.vue'

/** 중첩 값을 그리는 정렬 열의 `prop` → 서버 `sortProp` */
const SORT_ALIASES = Object.freeze({
  'topCust.custNm': 'topCustNm',
  'bankTp.nmLan': 'bankTpNm',
})

export default {
  mixins: [mainVueMixin, pagedListMixin],

  components: { CeoVerificationLine },

  data: function () {
    var data = initData()
    data.url = '/cust'
    data.cust = []

    data.bankTp = []

    /** 이 조건의 **전체** 매장 수 — 봉투가 같이 내린다(한 장을 세는 합계는 페이지마다 달라진다) */
    data.totalStoreCount = 0

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.closeDialogVisible = false
    return data
  },
  created: function () {
    this.initBankTp()
    this.custSearch('')
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.startDt': function (newVal) {
      if (!util.isEmpty(this.inputForm.startDt) && !util.isEmpty(this.inputForm.endDt)) {
        if (this.inputForm.startDt > this.inputForm.endDt) {
          this.formError.startDt = this.$t('가입일은 탈퇴일 이전의 일자만 설정 가능 합니다.')
          this.inputForm.startDt = this.inputForm.endDt
          this.formError.endDt = ''
        }
      }
    },
    'inputForm.endDt': function (newVal) {
      if (!util.isEmpty(this.inputForm.startDt) && !util.isEmpty(this.inputForm.endDt)) {
        if (this.inputForm.startDt > this.inputForm.endDt) {
          this.formError.endDt = this.$t('탈퇴일은 가입일 이후의 일자만 설정 가능 합니다.')
          this.formError.startDt = ''
          this.inputForm.endDt = this.inputForm.startDt
        }
      }
    },
  },
  computed: {
    /** 중첩 열의 정렬 축 — 기본 `{}` 를 주는 [pagedListMixin] 의 같은 이름을 덮어쓴다 */
    sortAliases: function () {
      return SORT_ALIASES
    },
  },
  methods: {
    /** 사업자 등록 번호 칸 — 저장 모양(하이픈 유무)과 상관없이 000-00-00000 으로 보인다(`utils/bizNumber`) */
    bizNoFormatter(row) {
      return bizNoDisplay(row.busiNum)
    },
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다(기본 50건·첫 페이지·서버 기본 정렬)
    initSearchForm: function () {
      return withPaging({
        topCustCd: null,
        custNm: '',
        useYn: 'Y',
        withStoreCount: true,
      })
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        custCd: 0,
        custNm: '',
        busiNum: '',
        ceoNm: '',
        useYn: 'Y',
        tel: '',
        fax: '',
        email: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        custDesc: '',
        topCust: { custCd: null, custNm: '' },
        files: [],
        delFiles: [],
        startDt: util.getNow('yyyy-MM-dd'),
        endDt: null,
        accountNumber: '',
        bankTp: null,
        accountName: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        custNm: '',
        busiNum: '',
        ceoNm: '',
        tel: '',
        fax: '',
        email: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        custDesc: '',
        'topCust.custCd': '',
        startDt: '',
        endDt: '',
        accountNumber: '',
        'bankTp.cd': '',
        accountName: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].custCd
      }
    },
    // 고객사 자동 검색 — 셀렉트 전용이라 **전량**이다. URL·조건은 [custOptionsQuery] 한 곳이 소유한다
    custSearch: function (custNm) {
      this.mainVue.$axios.search(
        CUST_OPTIONS_API,
        custOptionsQuery({ custNm: custNm }),
        function (result) {
          this.cust = pageRows(result)
        }.bind(this)
      )
    },
    // 정산은행구분 조회
    initBankTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/BANK_TP',
        null,
        function (result) {
          this.bankTp = result
        }.bind(this)
      )
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('사업장 추가')

      this.formError = this.initFormError()

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.custCd,
        function (result) {
          result.statu = 'U'
          result.title = this.$t('사업장 수정')

          if (util.isEmpty(result.topCust)) {
            result.topCust = { custCd: null, custNm: '' }
          }

          result.delFiles = []

          this.inputForm = result

          this.formError = this.initFormError()

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)
          this.totalStoreCount = (result && result.totalStoreCount) || 0

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('사업장 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      this.inputForm.files = this.inputForm.files.concat(this.inputForm.delFiles)

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            // 새 사업장 계정의 처음 비밀번호 — 이 응답에 한 번뿐이다(결정 47 ③)
            announceInitialAccount(this.$alert.bind(this), result)
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.custCd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 첨부 파일 추가
    custFileAdd: function (file, fileList) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data) {
          this.inputForm.files.push({
            url: data,
            name: file.name,
            status: 'ready',
          })
        }.bind(this)
      )
    },
    // 수정 시 업로드 했던 이미지 삭제 시 삭제 리스트에 저장
    custFileRemove: function (file, fileList) {
      var tmp = -1
      for (var i = 0, len = this.inputForm.files.length; i < len; i++) {
        if (this.inputForm.files[i].url == file.url) {
          tmp = i
        }
      }

      if (tmp > -1) {
        this.inputForm.files.splice(tmp, 1)
      }

      if (file.status == 'success') {
        file.status = 'del'
        this.inputForm.delFiles.push(file)
      }
    },
    fileNameChange: function (file) {
      if ('ready' != file.status) {
        file.status = 'change'
      }
    },
    /**
     * 주소 선택 — 위젯은 `utils/addressPicker` 한 곳이 만진다(종전 `initDaum` 다섯 사본을 접었다).
     * 채우는 필드(우편번호·주소)와 포커스 이동은 종전 그대로다.
     */
    selectAddress: async function () {
      let picked = null
      try {
        picked = await pickAddress({ geocode: false })
      } catch (error) {
        this.$message({ type: 'error', message: error.message })

        return
      }
      if (!picked) return

      this.inputForm.zipCd = picked.zonecode
      this.inputForm.addr = picked.address

      this.$refs.addr_dtl.focus()
    },
  },
}
</script>

<style scoped>
.cust-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  color: #606266;
}

.el-upload-list__item {
  -webkit-transition: none;
  transition: none;
}

.file_name .el-textarea__inner {
  height: 90px;
}
</style>
